import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { ConfigManagerService } from './config-manager.service';
import { UserService } from './user.service';

@Injectable({
	providedIn: 'root',
})
export class AppService {
	private _currentService: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);
	private _currentNavigation: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);
	private _docsUrl: string = environment.docs.customer;

	constructor(
		private router: Router,
		private userService: UserService,
		private configService: ConfigManagerService
	) {
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this._currentNavigation.next(event.url);
			}
		});
		this.initializeDocsUrl();
	}

	public get currentService(): Observable<string | undefined> {
		return this._currentService.asObservable();
	}

	public setCurrentService(service: string | undefined): void {
		if (service === this._currentService.value) {
			return;
		}
		this._currentService.next(service);
	}

	public get currentNavigation(): Observable<string | undefined> {
		return this._currentNavigation.asObservable();
	}

	private async initializeDocsUrl() {
		try {
			const isCancom = await this.userService.isCancomTenant();

			if (isCancom) {
				this._docsUrl = environment.docs.cancom;
			} else {
				this._docsUrl = await this.configService.getConfig<string>('documentation', environment.docs.customer);
			}
		} catch {
			this._docsUrl = environment.docs.customer;
		}
	}

	public get docsUrl(): string {
		return this._docsUrl;
	}
}
